/* eslint-disable no-unused-vars */
import React from "react";
//icons
import { IoIosArrowDown } from "react-icons/io";
// components
import { ISimpleData } from "../../../store/types/misc";

type ISelectOption = {
  label: string;
  placeholder: string;
  loading?: boolean;
  value?: string;
  icon?: React.ReactNode;
  onChange: (selected: string) => void;
  items: ISimpleData[];
  name?: string;
};

const SelectOption: React.FC<ISelectOption> = ({
  label,
  items,
  icon,
  value,
  name,
  onChange,
}) => {
  return (
    <div className="w-full">
      {label && (
        <div className="text-md tracking-wider mb-2 font-semibold">{label}</div>
      )}

      {/* GROUP container */}
      <div className="relative group flex w-full items-center rounded-lg py-2 border border-gray-300 hover:bg-[var(--accent)] ring-primary-500 focus-within:ring focus-within:ring-offset-2 overflow-hidden">
        {/* Optional icon */}
        {icon && (
          <div className="border-r w-[40px] flex justify-center items-center">
            {icon}
          </div>
        )}

        {/* SELECT field */}
        <div className="flex-1 overflow-hidden">
          <select
            value={value || ""}
            name={name}
            onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
              onChange(e.target.value)
            }
            className="w-full border-none outline-none bg-transparent h-full cursor-pointer px-3 appearance-none"
          >
            <option value="">Select</option>
            {(items || []).map((item) => (
              <option key={item.id} value={item.id}>
                {item.name}
              </option>
            ))}
          </select>
        </div>

        {/* Dropdown icon wrapper (absolute, reacts to group-hover) */}
        <div className=" absolute right-2 top-1/2 -translate-y-1/2 flex items-center justify-center w-6 rounded-full transition-colors group-hover:cursor-pointer duration-200">
          <IoIosArrowDown className="text-black" />
        </div>
      </div>
    </div>
  );
};

export default SelectOption;
